import React from 'react'
import { LEGISLATION_CATEGORIES, LEGISLATION_FOLDERS, LEGISLATION_MENU } from 'constants/controllers'
import Grid from '@material-ui/core/Grid'
import Icon from 'components/shared/Icon'
import getUrl from 'front-end-core/core/url'
import ArrowLink from 'components/redesign/ArrowLink'
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant'
import Xml from 'components/shared/Xml'

const LegislationBreadcrumbs = ({ aol, act, actIdMap, isProxy = false }) => {
  const legActValue = actIdMap && actIdMap.has(act) ? actIdMap.get(act) : null

  return (
    <div className='layout-width-constraint pt9 f5'>
      <Grid container alignItems='center'>
        <Grid item className='pr4'>
          <Icon name='icon-legislation' className='w7 vm' />
        </Grid>
        <Grid item className='black pr4'>
          <a className='black no-underline hover-underline' href={getUrl(LEGISLATION_FOLDERS, { aol })}>
            Legislation
          </a>
          {'\xa0 >'}
        </Grid>
        {!isProxy && legActValue && (
          <>
            <Grid item className='black pr4'>
              <a className='black no-underline hover-underline' href={getUrl(LEGISLATION_CATEGORIES, { aol }, { name: legActValue.folderName })}>
                {legActValue.folderName}
              </a>
              {'\xa0 >'}
            </Grid>
            <Grid item className='dark-orchid pr6'>
              {legActValue.category}
            </Grid>
          </>
        )}
        <Grid item className='mt1'>
          <div>
            <ArrowLink text='View all' textCx='pr4' url={getUrl(LEGISLATION_MENU, { aol })} />
          </div>
        </Grid>
      </Grid>
      {!isProxy && legActValue && legActValue.actNote ? <ActNote {...legActValue.actNote} /> : null}
    </div>
  )
}

const ActNote = ({ description, icon }) => (
  <div className='flex items-center bg-tangerine-dream b pl6 pv3 mv3 br1'>
    {description && <Xml component='div' render={description} />}
    {icon && <NotificationImportantIcon classes={{ root: 'ml4 dark-coral' }} />}
  </div>
)

export default LegislationBreadcrumbs
